var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 6.36655C12 4.69818 10.6475 3.3457 8.97915 3.3457H6.02085C4.35248 3.3457 3 4.69818 3 6.36655C3 8.0349 4.35248 9.38735 6.02085 9.38735H6.6V10.8457C6.6 10.8457 12 10.1166 12 6.36655Z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.25 14.3457C9.25 15.4507 8.355 16.3457 7.25 16.3457C6.145 16.3457 5.25 15.4507 5.25 14.3457C5.25 13.2407 6.145 12.3457 7.25 12.3457C8.355 12.3457 9.25 13.2407 9.25 14.3457Z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.25 17.3457C5.83155 17.3457 3 18.0604 3 19.4791V21.3457H11.5V19.4791C11.5 18.0604 8.66845 17.3457 7.25 17.3457Z"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.75 16.3457C17.855 16.3457 18.75 15.4507 18.75 14.3457C18.75 13.2407 17.855 12.3457 16.75 12.3457C15.645 12.3457 14.75 13.2407 14.75 14.3457C14.75 15.4507 15.645 16.3457 16.75 16.3457Z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.75 17.3457C15.3316 17.3457 12.5 18.0604 12.5 19.4791V21.3457H21V19.4791C21 18.0604 18.1684 17.3457 16.75 17.3457Z"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0208 3.8457C14.3524 3.8457 13 5.19818 13 6.86655C13 10.6166 17.8 11.3457 17.8 11.3457V9.88735H17.9792C19.6476 9.88735 21 8.5349 21 6.86655C21 5.19818 19.6476 3.8457 17.9792 3.8457H16.0208Z"
});
function SvgEncountersIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncountersIcon3);
export default __webpack_public_path__ + "static/media/encounters-icon3.490bee84ded4e883b2cac6287f01267e.svg";
export { ForwardRef as ReactComponent };